import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';

@injectable()
class CommentService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getComments(taskId, params) {
    const result = await this.apiService.get(`/organizer/tasks/${taskId}/comments`, params);
    return result.data.data.items;
  }

  async createComment(taskId, message) {
    const result = await this.apiService.post(`/organizer/tasks/${taskId}/comments`, {
      content: message,
    });
    return result.data.data.items;
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), CommentService, 0);

export default CommentService;
